import { Price, StatusBottomBar, StatusContainerWithActionBar } from 'components/secondaryMarket/shared/status';
import { ProgressBar } from 'components/shared/ProgressBar/ProgressBar';
import { useProgressTimer } from 'hooks/useProgressTimer';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import type { SecondaryPriceType } from 'state/secondaryMarket/productSearch';

import { Countdown } from '../../../../../shared/status/Countdown';

type Props = {
  tradeAuthStartTimeInMillis: number;
  tradeAuthDurationInMillis: number;
  price: number;
  priceType: SecondaryPriceType;
  priceCurrency: string;
};

export const QuotedStatus: FC<Props> = ({
  price,
  priceType,
  priceCurrency,
  tradeAuthDurationInMillis,
  tradeAuthStartTimeInMillis,
}) => {
  const { formatMessage } = useIntl();
  const { progressInPercent, remainingTimeInSeconds } = useProgressTimer(
    tradeAuthStartTimeInMillis,
    tradeAuthDurationInMillis,
  );

  return (
    <>
      <StatusContainerWithActionBar
        id="quote-realtime-sidePanel-settlementPrice"
        className="w-100 d-flex flex-column mb-0 alert alert-discreet-info rounded-top-3"
      >
        <div className="align-middle d-flex">
          <span className="display-5">{formatMessage({ id: 'secondaryMarket.sidePanel.label.settlementPrice' })}</span>
        </div>
        <div className="card-body px-0 py-2">
          <Price price={price} priceType={priceType} priceCurrency={priceCurrency}>
            <Countdown remainingTimeInSeconds={remainingTimeInSeconds} />
          </Price>
        </div>
      </StatusContainerWithActionBar>
      <div className="bg-info bg-opacity-05">
        <ProgressBar percent={100 - progressInPercent} className="bg-info" />
      </div>
      <StatusBottomBar className="w-100 d-flex mb-0 text-info bg-info bg-opacity-10 rounded-bottom-3">
        <div className="card-body px-3">
          <em className="icon icon-sm ">check_circle</em>
          <span className="ms-2" data-e2e="secondary-side-panel-status">
            {formatMessage({
              id: 'secondaryMarket.sidePanel.label.quoted',
            })}
          </span>
        </div>
      </StatusBottomBar>
    </>
  );
};
